import React, { useState, useEffect } from "react";
import Layout from "../../shared/Layout";
import DataTable from 'react-data-table-component';
import { DeleteProductRatingById, GetProductRatingAll, SaveProductRating } from "../../../_services";
import { ClipLoader } from 'react-spinners';
import { Rate } from "antd";
import { ToastContainer, toast } from "react-toastify";

// const baseUrl = process.env.REACT_APP_BASE_URL;

const CustomerReviews = () => {
    const [loading, setLoading] = useState(false);
    // const [productData, setProductData] = useState([]);
    const [filteredData, setFilteredData] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [customerRatingData, setCustomerRatingData] = useState([]);
    const [customerRatingId, setCustomerRatingId] = useState([]);
    const [isFormopen, setIsFormopen] = useState(false);

    const [formData, setFormData] = useState({
        ratingId: 0,
        loginId: 0,
        productId: 0,
        ratting: 0,
        remark: '',
        createdBy: 0,
        isActive: true
    });

    const fetchProductRatingAll = async () => {
        try {
            const data = await GetProductRatingAll();
            if (data.isSuccess === 200) {
                setCustomerRatingData((prevData) => {
                    if (JSON.stringify(prevData) !== JSON.stringify(data?.data)) {
                        const sortedData = data?.data?.sort((a, b) => {
                            return new Date(b.createdDate) - new Date(a.createdDate);
                        });

                        return sortedData;
                    }
                    return prevData;
                })
                setLoading(false);
            }
        } catch (error) {
            setCustomerRatingData([]);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleRatingChange = (value) => {
        setFormData(prevState => ({
            ...prevState,
            ratting: value,
        }));
    };

    const onSaveFaqs = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const data = await SaveProductRating(formData);
            if (data.isSuccess === 200) {
                fetchProductRatingAll();
                toast.success("Save Successfully");
                setFormData({
                    ratingId: 0,
                    loginId: 0,
                    productId: 0,
                    ratting: 0,
                    remark: '',
                    createdBy: 0,
                    isActive: true
                });
                setIsFormopen(false);
            }
        } catch (error) {
            toast.error("Please try again later.");
        }
        finally {
            setLoading(false);
        }
    };

    const onEditProductRating = (item) => {
        setCustomerRatingId(item?.ratingId)
        setIsFormopen(true);
        setFormData({
            ...formData,
            ratingId: item?.ratingId,
            loginId: item?.loginId,
            productId: item?.productId,
            ratting: item?.ratting,
            remark: item?.remark,
            isActive: item?.isActive
        })
    }

    const onDeleteProductRatingById = async (id) => {
        const isConfirmed = window.confirm("Are you sure you want to delete this item?");

        if (!isConfirmed) {
            return;
        }
        const data = await DeleteProductRatingById(id);
        if (data.isSuccess === 200) {
            fetchProductRatingAll();
            toast.success("Delete Successfully");
        }
    };

    useEffect(() => {
        fetchProductRatingAll();
    }, []);

    useEffect(() => {
        if (searchTerm) {
            const filtered = customerRatingData.filter(item =>
                (item.userName ? item.userName.toLowerCase() : '').includes(searchTerm.toLowerCase()) ||
                (item.productName ? item.productName.toLowerCase() : '').includes(searchTerm.toLowerCase())
            );

            setFilteredData(filtered);
        } else {
            setFilteredData(customerRatingData);
        }
    }, [searchTerm, customerRatingData]);

    const columns = [
        {
            name: 'S.No',
            selector: (row, index) => index + 1,
            sortable: false,
            width: '70px'
        },
        {
            name: 'Customer name',
            selector: row => (
                <span className="name_customer">
                    {row.userName}
                </span>
            ),
            sortable: false,
            width: '150px'
        },
        {
            name: 'Product Name',
            selector: row => (
                <div className="email_mobile">
                    <p className="mb-0">{row.productName}</p>
                </div>
            ),
            sortable: false,
            width: '200px'
        },
        {
            name: 'Ratting',
            cell: row => (
                <div className="d-flex align-items-center show_rating_star" style={{ gap: '3px' }}>
                    <Rate
                        allowHalf={true}
                        disabled
                        value={row.ratting}
                        count={row.ratting}
                        className="reating_star"
                    />
                    <span>{row.ratting}</span>
                    <span>{` (5)`}</span>
                </div>
            ),
            sortable: false,
            width: '200px'
        },
        {
            name: 'Remark',
            selector: row => (
                <div className="">
                    <span>{row?.remark}</span>
                </div>
            ),
            sortable: false,
            width: '250px'
        },
        {
            name: 'Review Date',
            selector: row => {
                if (row.createdDate) {
                    const date = new Date(row.createdDate);

                    // Convert to Indian Standard Time (IST)
                    const indianTime = new Date(date.toLocaleString('en-US', { timeZone: 'Asia/Kolkata' }));

                    // Format Date as dd/mm/yyyy
                    const day = String(indianTime.getDate()).padStart(2, '0');
                    const month = String(indianTime.getMonth() + 1).padStart(2, '0'); // months are 0-indexed
                    const year = indianTime.getFullYear();

                    return `${day}/${month}/${year}`;
                } else {
                    return 'N/A';
                }
            },
            sortable: true,
            width: '180px'
        },
        {
            name: 'Action',
            cell: row => (
                <div className="d-flex" style={{ gap: "10px" }}>
                    <span title='Edit' onClick={() => onEditProductRating(row)} className="edit_icon_wepper">
                        <i className="fas fa-pencil-alt"></i>
                    </span>
                    <span title='Delete' onClick={() => onDeleteProductRatingById(row.ratingId)} className="delete_icon_weepr">
                        <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 24 24">
                            <path d="M 10 2 L 9 3 L 4 3 L 4 5 L 5 5 L 5 20 C 5 20.522222 5.1913289 21.05461 5.5683594 21.431641 C 5.9453899 21.808671 6.4777778 22 7 22 L 17 22 C 17.522222 22 18.05461 21.808671 18.431641 21.431641 C 18.808671 21.05461 19 20.522222 19 20 L 19 5 L 20 5 L 20 3 L 15 3 L 14 2 L 10 2 z M 7 5 L 17 5 L 17 20 L 7 20 L 7 5 z M 9 7 L 9 18 L 11 18 L 11 7 L 9 7 z M 13 7 L 13 18 L 15 18 L 15 7 L 13 7 z" fill="#FF0000"></path>
                        </svg>
                    </span>
                </div>
            ),
            sortable: false
        }
    ];

    return (
        <Layout>
            <ToastContainer
                autoClose={400}
                hideProgressBar={true}
                closeOnClick
                pauseOnHover
                draggable
                className='toaster'
            />
            <div className="px-4">
                <div className="admin-page mt-4 d-sm-flex justify-content-between align-items-center">
                    <div className="admin-heading d-flex align-items-center" style={{ gap: "10px" }}>
                        <img src="./images/customer.png" style={{ width: '25px' }} alt="" />
                        <h4 className="mb-0">Customer Rating {`(${customerRatingData?.length})`}</h4>
                    </div>
                    <div className="d-md-flex align-items-center" style={{ gap: "20px" }}>
                        <div className="search-container col-md-12">
                            <input
                                type="text"
                                placeholder="Search..."
                                value={searchTerm}
                                onChange={(e) => setSearchTerm(e.target.value)}
                                className="form-control"
                            />
                        </div>
                        {/* <div className="add_btn">
                            <button onClick={onOpen}>Add Product Detail</button>
                        </div> */}
                    </div>
                </div>

                <div className="datatable mt-4">
                    <DataTable
                        columns={columns}
                        data={filteredData || []}
                        progressPending={loading}
                        progressComponent={<p>Loading...</p>}
                        pagination
                        highlightOnHover
                    />
                </div>

                <div id="entryformContainer" className={`adminform entryform ${isFormopen ? 'open' : ''}`}>
                    <div className="closebtn">
                        <button className="" onClick={() => setIsFormopen(false)} >
                            <svg clipRule="evenodd" fillRule="evenodd" height="30" imageRendering="optimizeQuality" shapeRendering="geometricPrecision" textRendering="geometricPrecision" viewBox="0 0 6.82666 6.82666" width="30" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" >
                                <g transform="matrix(1,0,0,1,0,0)">
                                    <g id="Layer_x0020_1">
                                        <rect fill="#ffffff00" height="6.827" rx="1.507" width="6.827" stroke="none" />
                                        <path d="m2.21002 1.41333-.79669.79669 1.20331 1.20331-1.20331 1.20331.79669.79669 1.20331-1.20331 1.20332 1.20331.79668-.79669-1.2033-1.20331 1.2033-1.20331-.79669-.79669-1.20331 1.2033z" fill="#fffffe" stroke="none" />
                                    </g>
                                </g>
                            </svg>
                        </button>
                    </div>
                    <div className="enForm">
                        <div className="text-center form-heading">
                            <h4>Add Customer Rating</h4>
                        </div>
                        <form onSubmit={onSaveFaqs}>
                            <div className="form-group" >
                                <label htmlFor="formFile">Rating</label>
                                <div>
                                    <Rate
                                        value={formData.ratting}
                                        onChange={handleRatingChange}
                                        style={{ fontSize: '24px' }}
                                    />
                                </div>
                            </div>
                            <div className="form-group">
                                <label htmlFor="formFile">Remark</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    id="remark"
                                    name="remark"
                                    value={formData.remark}
                                    onChange={handleChange}
                                    required
                                />
                            </div>

                            <div className="d-flex form-buttons" style={{ gap: "15px" }}>
                                <div className="submit-btn pt-2">
                                    <button
                                        type="submit"
                                        disabled={loading}
                                    >
                                        {loading ? (
                                            <ClipLoader color="#fff" size={20} />
                                        ) : (
                                            customerRatingId ? 'Update' : 'Submit'
                                        )}
                                    </button>
                                </div>
                                {/* <div className="reset-btn pt-2">
                                    <button onClick={handleReset}>Reset</button>
                                </div> */}
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </Layout>
    )
}

export default CustomerReviews;